export const WS_EVENTS = {
    AUTHENTICATE: "authenticate",
    GET_UPDATES: "tprm:get_new_updates",
    GET_MESSAGES: "tprm:get_messages",
    SEND_MESSAGE: "tprm:send_message"
};

export const WS_STATUS = {
    CONNECTED: 'Connected',
    DISCONNECTED: 'Disconnected',
    ERROR: 'Error'
};
